import { FC, useEffect } from "react";
import { Popover } from "@headlessui/react";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import { useSearchParams } from "react-router-dom";

export interface GuestsInputProps {
  className?: string;
}

const GuestsInput: FC<GuestsInputProps> = ({ className = "flex-1" }) => {
  const [searchParams] = useSearchParams();
  const adults = parseInt(searchParams?.get("adults") ?? "1");
  const children = parseInt(searchParams?.get("children") ?? "0");

  const totalGuests = adults + children;

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  return (
    <Popover className={`flex relative ${className}`}>
      {({ open }) => (
        <div
          className={`flex-1 flex items-center focus:outline-none rounded-b-3xl ${
            open ? "shadow-lg" : ""
          }`}
        >
          <Popover.Button
            className={`relative z-10 flex-1 flex text-left items-center p-3 space-x-3 focus:outline-none`}
          >
            <div className="text-neutral-300 dark:text-neutral-400">
              <UserPlusIcon className="w-5 h-5 lg:w-7 lg:h-7" />
            </div>
            <div className="flex-grow">
              <span className="block xl:text-lg font-semibold">
                {totalGuests < 2
                  ? ` ${totalGuests} Hóspede`
                  : ` ${totalGuests} Hóspedes`}
              </span>
              <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                {totalGuests ? "Hóspedes" : "Adicionar hóspedes"}
              </span>
            </div>
          </Popover.Button>
        </div>
      )}
    </Popover>
  );
};

export default GuestsInput;
